import headsetIcon from "../../assets/images/footer/headset.png";
import emaqiIcon from "../../assets/images/footer/email.png";
import pinIcon from "../../assets/images/footer/pin.png";
import instaIcon from "../../assets/images/footer/instagram.png";
import telegramIcon from "../../assets/images/footer/telegram.png";
import aparatIcon from "../../assets/images/footer/aparat.png";
import linkedinIcon from "../../assets/images/footer/linkedin.png";
import { useState } from "react";
import addNewUserToNewsletter from "../../services/addNewsletterService";
const Footer = () => {
  const [newsletterInput, setNewsletterInput] = useState({
    Email: "",
    MobileNumber: "",
    Refrence: "Index",
  });
  const newsLetterInputHandler = (e) => {
    setNewsletterInput({ ...newsletterInput, [e.target.name]: e.target.value });
  };

  const submitNewsletter = async (e) => {
    if (!newsletterInput.Email) {
      alert("لطفا شماره تماس یا ایمیل خود را وارد کنید!");
      return;
    }
    try {
      await addNewUserToNewsletter(newsletterInput);
      setNewsletterInput({ Email: "", MobileNumber: "", Refrence: "Index" });
    } catch (error) {}
  };

  return (
    <footer className="bg-lightGrayKite w-full">
      <div className="container mx-auto py-8">
        <section className="bg-darkGrayKite flex justify-between items-start flex-col px-7 md:px-24 py-4 gap-5 md:flex-row md:items-center">
          <div className="flex flex-row justify-center items-center gap-4 text-white text-right">
            <div className="w-14 h-14">
              <img src={headsetIcon} alt="تماس" />
            </div>
            <div>
              <div>تماس</div>
              <div>
                <a className="font-bold" href="tel:982175097700">
                  021-75097700
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-center items-center gap-4 text-white text-right">
            <div className="w-14 h-14">
              <img src={pinIcon} alt="آدرس" />
            </div>
            <div>
              <div>آدرس</div>
              <div className="font-bold">
                تهران، خیابان مطهری، پلاک 188 طبقه 1
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-center items-center gap-4 text-white text-right">
            <div className="w-14 h-14">
              <img src={emaqiIcon} alt="ایمیل" />
            </div>
            <div>
              <div>ایمیل</div>
              <div>
                <a className="font-bold" href="mailto:info@kite.ir">
                  info@kite.ir
                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="grid grid-cols-12 gap-4 py-8 px-7 xl:px-0">
          <div className="col-span-6 md:col-span-4 lg:col-span-2">
            <h3 className="text-white mb-3 font-bold">درباره کایت</h3>
            <ul className="text-stone-400">
              <li className="mb-2">
                <a href="https://kite.ir/site/agencyrequest">درخواست همکاری </a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/contact">تماس با ما</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/about">درباره ما</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/policy">قوانین و مقررات</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/purchaseGuide">راهنمای خرید</a>
              </li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4 lg:col-span-2">
            <h3 className="text-white mb-3 font-bold">تورهای پرطرفدار</h3>
            <ul className="text-stone-400">
              <li className="mb-2">
                <a href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%DA%A9%D9%88%DB%8C%D8%B1-%DA%AF%D8%B1%D8%AF%DB%8C">
                  تورهای کویر گردی
                </a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%DB%8C%DA%A9-%D8%B1%D9%88%D8%B2%D9%87">
                  تورهای یک روزه
                </a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%B7%D8%A8%DB%8C%D8%B9%D8%AA-%DA%AF%D8%B1%D8%AF%DB%8C">
                  تورهای طبیعت گردی
                </a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%A7%D9%82%D8%B3%D8%A7%D8%B7%DB%8C">
                  تورهای اقساطی
                </a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%A7%D8%B3%D8%AA%D8%A7%D9%86%D8%A8%D9%88%D9%84">
                  تورهای استانبول
                </a>
              </li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4 lg:col-span-2">
            <h3 className="text-white mb-3 font-bold">صفحات کاربردی</h3>
            <ul className="text-stone-400">
              <li className="mb-2">
                <a href="https://kite.ir/flight">بلیط هواپیما</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/visa">راهنمای اخذ ویزا</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/hotel">رزرو هتل</a>
              </li>
              <li className="mb-2">
                <a href="https://kite.ir/blog">مجله گردشگری</a>
              </li>
            </ul>
          </div>
          <div className="col-span-12 lg:col-span-6">
            <h3 className="text-white mb-3 font-bold">
              آژانس مسافرتی پیام توسعه صبا
            </h3>
            <p className="text-stone-500">
              کایت با ارائه خدمات گردشگری آنلاین پا به پات تا مقصد میاد. هر کجای
              دنیا و هر ساعت از شبانه‌روز که هست؛ در سایت کایت آنلاین شو و با
              چند کلیک بلیط هواپیما، بلیط چارتر، هتل و تورهای مسافرتی و
              طبیعت‌گردی خودت رو رزرو کن.{" "}
            </p>
            <div className="flex justify-between lg:justify-start lg:gap-x-4 gap-2 mt-7">
              <div className="flex-1 max-w-[65px] bg-white h-12 rounded overflow-hidden">
                <a href="https://logo.samandehi.ir/Verify.aspx?id=1013511&p=rfthobpdrfthxlaodshwrfthrfth">
                  <img
                    alt="logo-samandehi"
                    src="https://logo.samandehi.ir/logo.aspx?id=1013511&amp;p=nbpdlymanbpdqftiujynnbpdnbpd"
                  />
                </a>
              </div>
              <div className="flex-1 max-w-[65px] bg-white h-12 rounded overflow-hidden">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://trustseal.enamad.ir/?id=83945&amp;Code=Gcc0JxrDn1YKuxlOXRT0"
                >
                  <img
                    src="https://Trustseal.eNamad.ir/logo.aspx?id=83945&amp;Code=Gcc0JxrDn1YKuxlOXRT0"
                    alt=""
                    id="Gcc0JxrDn1YKuxlOXRT0"
                  />
                </a>
              </div>
              <div className="flex-1 max-w-[65px] bg-white h-12 rounded overflow-hidden">
                <a href="https://www.cao.ir/">
                  <img src="/Content/Website/img/cao.png" alt="cao" />
                </a>
              </div>
              <div className="flex-1 max-w-[65px] bg-white h-12 rounded overflow-hidden">
                <a href="https://aira.ir/">
                  <img src="/Content/Website/img/aira.png" alt="aira" />
                </a>
              </div>
              <div className="flex-1 max-w-[65px] bg-white h-12 rounded overflow-hidden">
                <a href="https://www.cao.ir/paxrights">
                  <img
                    src="/Content/Website/img/paxrights.png"
                    alt="paxrights"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-darkGrayKite flex justify-between items-start flex-col px-7 md:px-24 py-8 gap-5 md:flex-row md:flex-wrap lg:flex-nowrap md:items-center">
          <h3 className="text-stone-400 w-full text-center">
            همراهی با کایت در شبکه‌های اجتماعی
          </h3>
          <div className="w-full px-6">
            <ul className="flex items-center justify-between">
              <li className="bg-lightGrayKite w-14 h-14 rounded p-3">
                <a
                  href="https://www.instagram.com/kite.ir"
                  target="_blank"
                  rel="noreferrer"
                  className="block w-full h-full"
                >
                  <img src={instaIcon} alt="instaIcon" />
                </a>
              </li>
              <li className="bg-lightGrayKite w-14 h-14 rounded p-3">
                <a href="https://t.me/kite" target="_blank" rel="noreferrer">
                  <img src={telegramIcon} alt="telegramIcon" />
                </a>
              </li>
              <li className="bg-lightGrayKite w-14 h-14 rounded p-3">
                <a
                  href="https://www.aparat.com/kite.ir"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={aparatIcon} alt="aparatIcon" />
                </a>
              </li>
              <li className="bg-lightGrayKite w-14 h-14 rounded p-3">
                <a
                  href="https://www.linkedin.com/company/kite-ir"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={linkedinIcon} alt="linkedinIcon" />
                </a>
              </li>
            </ul>
          </div>
          <div className="w-full">
            <p className="text-stone-400 text-center">
              ثبت‌نام در <span className="text-white">خبرنامه</span> و{" "}
              <span className="text-white">آفر تور‌ها</span>
            </p>
          </div>
          <div className="w-full flex h-12">
            <input
              value={newsletterInput.Email}
              name="Email"
              onChange={newsLetterInputHandler}
              className="flex-grow-[2] bg-lightGrayKite text-stone-400 px-4 rounded-tr-md rounded-br-md text-sm outline-none focus:outline-none"
              placeholder="تلفن / ایمیل خود را وارد کنید"
            />
            <button
              onClick={submitNewsletter}
              className="bg-[#125f60] text-white px-4 rounded-tl-md rounded-bl-md"
            >
              عضویت
            </button>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
